export const flipOrder = order => (order === 'asc' ? 'desc' : 'asc');
